import React from 'react'
import LegalLayout, { Section, Para, Bullets, Accent } from '../components/LegalLayout'

const RefundPolicy = () => {
  return (
    <LegalLayout title='Refund & Cancellation Policy' lastUpdated='25 June 2026'>
        <Para>
          At <Accent>Nilay Singh</Accent>, we strive to ensure that you are satisfied with our
          services and products. This Refund &amp; Cancellation Policy explains the circumstances
          under which refunds are provided and how you can request one.
        </Para>

        <Section heading='1. Refund Window'>
          <Para>
            You may request a refund within <Accent>7 (seven) days</Accent> of the date of your
            payment. Refund requests made after this period may not be accepted.
          </Para>
        </Section>

        <Section heading='2. Eligibility for a Refund'>
          <Para>A refund may be granted in cases such as:</Para>
          <Bullets items={[
            'A duplicate or accidental payment was made.',
            'You were charged an incorrect amount.',
            'The agreed service or product was not delivered.',
            'A technical error resulted in a failed transaction where the amount was still debited.'
          ]} />
        </Section>

        <Section heading='3. Non-Refundable Cases'>
          <Para>Refunds will generally not be provided where:</Para>
          <Bullets items={[
            'Work or delivery has already been completed and accepted.',
            'The request is made after the 7-day refund window.',
            'A change of mind occurs after a service has been substantially performed.',
            'Delays or issues are caused by incomplete or inaccurate information provided by you.'
          ]} />
        </Section>

        <Section heading='4. Cancellations'>
          <Para>
            You may request to cancel a service before work has begun for a full refund. If work has
            already started, a refund may be issued on a pro-rata basis for the portion of work not yet
            completed, at our reasonable discretion.
          </Para>
        </Section>

        <Section heading='5. How to Request a Refund'>
          <Para>
            To request a refund, please contact us using the details below with your payment reference,
            the date of the transaction, and the reason for your request. We will review every request
            fairly and respond promptly.
          </Para>
        </Section>

        <Section heading='6. Processing of Refunds'>
          <Para>
            Approved refunds will be processed through the original payment method via <Accent>Razorpay</Accent>.
            Once approved, refunds are typically credited within <Accent>5–7 business days</Accent>,
            though the exact timing may depend on your bank or payment provider.
          </Para>
        </Section>

        <Section heading='7. Contact Us'>
          <Para>For any refund or cancellation requests, please reach out to us at:</Para>
          <Bullets items={[
            <><Accent>Name:</Accent> Nilay Singh</>,
            <><Accent>Email:</Accent> snilay011@gmail.com</>,
            <><Accent>Phone:</Accent> +91 9810237655</>,
            <><Accent>Address:</Accent> Shipra Riviera, Indirapuram, Ghaziabad, Uttar Pradesh, India</>
          ]} />
        </Section>
    </LegalLayout>
  )
}

export default RefundPolicy
